const style = {
  table: {
    loader: {
      align: 'center',
    },
    sx: { minWidth: 700 },
    head: {
      sx: {
        visibility: 'visible',
      },
    },
  },
  pagination: {
    component: 'div',
  },
  totalCountRow: {
    size: 'small',
    sx: {
      pt: '6px',
      pl: '20px',
      pb: '6px',
      color: 'text.secondary',
    },
    text: {
      variant: 'overline',
    },
  },
  tableColumn: {
    box: {
      sx: {
        alignItems: 'center',
        display: 'flex',
      },
    },
    avatar: {
      variant: 'circular',
      sx: {
        color: 'primary.main',
        height: 42,
        width: 42,
      },
    },
    rowBox: {
      sx: {
        ml: 1,
        width: 120,
      },
      textFirst: {
        variant: 'subtitle2',
      },
      textSecond: {
        color: 'textSecondary',
        variant: 'body2',
      },
    },
    chip: {
      variant: 'outlined',
    },
    matchChip: {
      sx: {
        minWidth: 0.6,
      },
    },
  },
} as const;

export default style;
